
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/kl/[slug]",
      function () {
        return require("private-next-pages/sitemap/kl/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/kl/[slug]"])
      });
    }
  